import { OrderBy } from '../service/types'

export enum CreatedFrom {
  CLUB = 'CLUB',
  ONLINE_EVENT = 'ONLINE_EVENT',
  SPARKLE = 'SPARKLE',
  WEBINAR = 'WEBINAR',
  ON_FIRE = 'ON_FIRE'
}

export enum Visibility {
  PUBLIC = 'PUBLIC',
  CLUB = 'CLUB',
  HOTMART = 'HOTMART',
  DEFAULT = 'DEFAULT',
  PRIVATE = 'PRIVATE'
}

export enum PlaybackStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DOWNLOAD_AVAILABLE = 'DOWNLOAD_AVAILABLE',
  DISCONNECTED = 'DISCONNECTED'
}

export enum Provider {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  HOTMART = 'HOTMART',
  YOUTUBE_HOTMART = 'YOUTUBE_HOTMART',
  MUX_STUDIO_HOTMART = 'MUX_STUDIO_HOTMART'
}

export enum Status {
  CREATING = 'CREATING',
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  CLOSING = 'CLOSING',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
  FAILED = 'FAILED'
}

export enum LiveToggle {
  API_LIVE_MANAGER_ENABLE_MUX_STUDIO = 'API_LIVE_MANAGER_ENABLE_MUX_STUDIO'
}

export interface Transmission {
  amountLead: number,
  averageRating: number,
  code: string,
  completedAt?: string,
  conversationId: string,
  createdFrom: CreatedFrom,
  description: string,
  enableVodPlayback: boolean,
  inputKey: string,
  inputUrl: string,
  largeThumbnailLink: string,
  liveStartAt: string,
  maxDurationMinutes: number,
  maxParticipants: number,
  muxStudioId: string | null,
  mediaCode: string,
  name: string,
  playbackStatus: PlaybackStatus,
  projectId?: string,
  provider: Provider,
  smallThumbnailLink: string,
  status: Status,
  url: string,
  visibility: Visibility,
  zoneId: string,
  youtubePrivacy: YoutubePrivacySchema | null,
  embedHtml: string,
  playerJwt: string,
  applicationCode: string,
  userCode: string
}

export enum ScheduleOption {
  NOW = 'NOW',
  LATER = 'LATER'
}

export enum FormSection {
  DETAILS = 'details',
  ENABLE_VOD_PLAYBACK = 'enableVodPlayback',
  INFO = 'info',
  SCHEDULE = 'schedule',
  THUMBNAIL = 'thumb'
}

export enum EnableVodPlayback {
  YES = '1',
  NO = '0'
}

export enum YoutubePrivacySchema {
  PUBLIC = 'PUBLIC',
  UNLISTED = 'UNLISTED'
}

export interface InvalidTokenError {
  code?: string,
  message?: string
}

export interface FetchTransmissionsPayload {
  page: number,
  size: number,
  status?: Status,
  sort: OrderBy,
  name: string
}
